import { hasFeature } from '../../infrastructure/feature'
import { AdminCategory } from './adminModels'
import { Claims } from '../../infrastructure/signIn/models'

export function Categories(): AdminCategory[] {
    return [
        {
            name: 'administration',
            cards: [
                {
                    name: 'featureToggle',
                    claims: [Claims.FeatureToggle],
                    hasDescription: true
                },
                {
                    name: 'refreshData',
                    claims: [Claims.RefreshData],
                    hasDescription: true
                },
                {
                    name: 'clearData',
                    claims: [Claims.ClearData],
                    hasDescription: true
                },
                {
                    name: 'impersonate',
                    claims: [Claims.Impersonate],
                    hasDescription: true
                },
                {
                    name: 'backgroundDiagnostics',
                    claims: [Claims.Diagnostics],
                    hasDescription: true
                },
                {
                    name: 'profile',
                    claims: [Claims.UserPersonaManager],
                    hasDescription: true
                },
                {
                    name: 'persona',
                    claims: [Claims.PersonaManager],
                    hasDescription: true
                }
            ]
        },
        {
            name: 'company',
            cards: [
                {
                    name: 'company',
                    claims: [Claims.MasterdataCompanyManager, Claims.MasterdataCompanyReader]
                },
                {
                    name: 'counterparty',
                    claims: [Claims.MasterdataCounterpartyManager, Claims.MasterdataCounterpartyReader]
                },
                {
                    name: 'companyDutyStatus',
                    claims: [Claims.MasterdataCompanyDutyStatusManager, Claims.MasterdataCompanyDutyStatusReader]
                }
            ]
        },
        {
            name: 'deals',
            cards: [
                {
                    name: 'dealType',
                    claims: [Claims.MasterdataDealTypeManager, Claims.MasterdataDealTypeReader]
                },
                {
                    name: 'pricingPeriod',
                    claims: [Claims.MasterdataPricingPeriodManager]
                },
                {
                    name: 'regulatedPrice',
                    claims: [Claims.MasterdataRegulatedPriceManager, Claims.MasterdataRegulatedPriceReader]
                },
                {
                    name: 'quantityUnitPrice',
                    claims: [Claims.MasterdataQuantityUnitPriceManager, Claims.MasterdataQuantityUnitPriceReader]
                },
                {
                    name: 'paymentTerm',
                    claims: [Claims.MasterdataPaymentTermReader],
                    url: 'deal/allPaymentTerms'
                },
                {
                    name: 'priceIndex',
                    claims: [Claims.MasterdataPriceIndexReader, Claims.MasterdataPriceIndexManager]
                },
                {
                    name: 'dealValidatorEmail',
                    claims: [Claims.MasterdataDealValidatorEmailReader],
                    url: 'deal/dealValidatorEmail'
                },
                {
                    name: 'validationProcess',
                    claims: [Claims.MasterdataValidationProcessReader],
                    url: 'deal/validationProcess'
                },
                {
                    name: 'incoterm',
                    claims: [Claims.MasterdataIncoTermReader],
                    url: 'deal/incoterm'
                },
                {
                    name: 'dealFields',
                    claims: [Claims.MasterdataDealFieldsReader],
                    url: 'deal/dealFields'
                },
                {
                    name: 'quantityPriceUnitRules',
                    claims: [Claims.MasterdataQuantityPriceUnitRulesReader],
                    url: 'deal/quantityPriceUnitRules'
                },
                {
                    name: 'supplyDealDefaultValue',
                    claims: [Claims.MasterdataSupplyDealDefaultValueManager, Claims.MasterdataSupplyDealDefaultValueReader]
                },
                {
                    name: 'das',
                    claims: [Claims.MasterdataDasReader],
                    url: 'deal/das/masterdata'
                },
                {
                    name: 'quotationCalendar',
                    claims: [Claims.MasterdataQuotationCalendarManager],
                },
                {
                    name: 'pricingPeriodRule',
                    claims: [Claims.MasterdataPricingPeriodRuleManager, Claims.MasterdataPricingPeriodRuleReader]
                }
            ]
        },
        {
            name: 'product',
            cards: [
                {
                    name: 'productCompany',
                    claims: [Claims.MasterdataProductCompanyManager, Claims.MasterdataProductCompanyWriter]
                },
                {
                    name: 'productgroup',
                    claims: [Claims.MasterdataProductGroupCompulsoryStockLevel]
                },
                {
                    name: 'localproduct',
                    claims: [Claims.MasterdataLocalProduct]
                },
                {
                    name: 'product',
                    claims: [Claims.MasterdataProductReader, Claims.MasterdataProductWriter, Claims.MasterdataProductManager]
                },
                {
                    name: 'roadSalesProduct',
                    claims: [Claims.MasterdataRoadSalesProductManager, Claims.MasterdataRoadSalesProductReader]
                },
                {
                    name: 'cpdpFamily',
                    claims: [Claims.MasterdataRoadSalesProductManager, Claims.MasterdataRoadSalesProductReader],
                    url: 'masterdata/roadSalesProduct/cpdpFamily'
                },
                {
                    name: 'marketingFamily',
                    claims: [Claims.MasterdataRoadSalesProductManager, Claims.MasterdataRoadSalesProductReader],
                    url: 'masterdata/roadSalesProduct/marketingFamily'
                }
            ]
        },
        {
            name: 'sap',
            cards: [
                {
                    name: 'sapCounterparty',
                    claims: [Claims.MasterdataSapCounterpartyManager, Claims.MasterdataSapCounterpartyReader]
                },
                {
                    name: 'sapCounterpartyDealType',
                    claims: [Claims.MasterdataSapCounterpartyManager, Claims.MasterdataSapCounterpartyReader]
                },
                {
                    name: 'storageLocation',
                    claims: [Claims.MasterdataPlantStorageLocationManager, Claims.MasterdataPlantStorageLocationWriter]
                },
                {
                    name: 'plant',
                    claims: [Claims.MasterdataPlantManager]
                },
                {
                    name: 'sapShipTo',
                    claims: [Claims.MasterdataSapShipToReader, Claims.MasterdataSapShipToManager]
                },
                {
                    name: 'sapPurchaseOrganization',
                    claims: [Claims.MasterdataSapPurchaseOrganizationReader],
                    url: 'masterdata/sapCounterparty/allSapPurchaseOrganization'
                },
                {
                    name: 'productSAPCode',
                    claims: [Claims.MasterdataProductSAPCodeReader],
                    url: 'deal/allProductSapCodes'
                },
                {
                    name: 'sapCustomerSegment',
                    claims: [Claims.MasterdataSapCustomerSegmentReader],
                    url: 'sapApi/sapCustomerSegments'
                },
                {
                    name: 'sapDocumentType',
                    claims: [Claims.MasterdataSapDocumentTypeReader],
                    url: 'sapApi/sapDocumentTypes'
                },
                {
                    name: 'sapDealFieldPricingConditions',
                    claims: [Claims.MasterdataSapDealFieldPricingConditionsReader],
                    url: 'masterdata/dealFieldPricingConditions'
                },
                {
                    name: 'sapPricingConditionFieldMappings',
                    claims: [Claims.MasterdataSapDealFieldPricingConditionsReader],
                    url: 'masterdata/pricingConditionFieldMappings'
                }
            ]
        },
        {
            name: 'stock',
            cards: [
                {
                    name: 'stockCapacity',
                    claims: [Claims.MasterdataStockCapacityManager, Claims.MasterdataStockCapacityReader],
                    hasDescription: true
                },
                {
                    name: 'compulsoryStock',
                    claims: [Claims.MasterdataCompulsoryStockLevel],
                    hasDescription: true
                },
                {
                    name: 'physicalStock',
                    claims: [Claims.MasterdataPhysicalStockManager, Claims.MasterdataPhysicalStockReader],
                    hasDescription: true
                },
                {
                    name: 'tactixOutput',
                    claims: [Claims.TactixOutputReader],
                    url: 'stock/movement/mktsale/tactixOutput'
                },
                {
                    name: 'unusableStockPropagationPeriods',
                    claims: [Claims.MasterdataUnusableStockPropagationPeriods],
                    url: 'stock/unusableStockPropagationPeriods'
                },
                {
                    name: 'gainsAndLossesCategory',
                    claims: [Claims.MasterdataGainsAndLossesCategoryReader],
                    url: 'sapApi/gainsAndLossesCategory'
                },
                {
                    name: 'maxStockDays',
                    claims: [Claims.MasterdataMaxStockDaysReader],
                    url: 'stock/maxStockDays'
                },
            ]
        },
        {
            name: 'site',
            cards: [
                {
                    name: 'supplyOrigin',
                    claims: [Claims.MasterdataSupplyOriginManager, Claims.MasterdataSupplyOriginReader]
                },
                {
                    name: 'supplyDestination',
                    claims: [Claims.MasterdataSupplyDestinationManager, Claims.MasterdataSupplyDestinationWriter, Claims.MasterdataSupplyDestinationReader]
                },
                {
                    name: 'site',
                    claims: [Claims.MasterdataSiteManager, Claims.MasterdataSiteReader]
                },
                {
                    name: 'supplyPlantAssignment',
                    claims: [Claims.MasterdataSupplyPlantAssignmentReader, Claims.MasterdataSupplyPlantAssignmentManager]
                }
            ]
        },
        {
            name: 'vessel',
            cards: [
                {
                    name: 'vesselDelay',
                    claims: [Claims.MasterDataVesselDelayManager, Claims.MasterDataVesselDelayReader]
                },
                {
                    name: 'jetty',
                    claims: [Claims.MasterdataJettyManager, Claims.MasterdataJettyReader, Claims.MasterdataJettyWriter]
                },
                {
                    name: 'defaultPricingDensity',
                    claims: [Claims.MasterdataDefaultPricingDensityReader],
                    url: 'vessel/defaultPricingDensity'
                },
            ]
        },
        {
            name: 'transport',
            cards: [
                {
                    name: 'vehicle',
                    claims: [Claims.MasterdataVehicleManager, Claims.MasterdataVehicleReader]
                },
                {
                    name: 'meanOfTransportation',
                    claims: [Claims.MasterdataMeanOfTransportationReader],
                    url: 'stock/movement/masterdataMeanOfTransportation'
                }
            ]
        },
        {
            name: 'utils',
            cards: [
                {
                    name: 'calendar',
                    claims: [Claims.MasterdataCalendarManager, Claims.MasterdataCalendarReader]
                },
                {
                    name: 'conversionFactor',
                    claims: [Claims.MasterdataCommonReader],
                    url: 'quantity/conversionFactor'
                },
                {
                    name: 'documentPath',
                    claims: [Claims.MasterdataDocumentPathManager, Claims.MasterdataDocumentPathReader],
                    url: 'document/documentPath'
                }
            ]
        },
        {
            name: 'customer',
            cards: [
                {
                    name: 'customerSegment',
                    claims: [Claims.MasterdataCustomerSegmentReader, Claims.MasterdataCustomerSegmentManager]
                },
                {
                    name: 'customerSegmentProduct',
                    claims: [Claims.MasterdataCustomerSegmentProductReader, Claims.MasterdataCustomerSegmentProductManager]
                }
            ]
        },
        {
            name: 'pipeline',
            cards: hasFeature('MessageMovements') ? [
                {
                    name: 'transcosCounterParty',
                    claims: [Claims.MasterdataPublicPipeLineTranscoDisplay, Claims.MasterdataPublicPipeLineTranscoManager]
                },
                {
                    name: 'transcosProduct',
                    claims: [Claims.MasterdataPublicPipeLineTranscoDisplay, Claims.MasterdataPublicPipeLineTranscoManager]
                },
                {
                    name: 'transcosSite',
                    claims: [Claims.MasterdataPublicPipeLineTranscoDisplay, Claims.MasterdataPublicPipeLineTranscoManager]
                },
                {
                    name: 'messagesRules',
                    claims: [Claims.MasterdataMovementMessagesRulesReader],
                    url: 'stock/movementMessage/messagesRules'
                }
            ] : []
        },
        {
            name: 'primo',
            cards: [
                {
                    name: 'primoMovementType',
                    claims: [Claims.MasterdataPrimoMovementTypeReader],
                    url: 'report/primo/primoMovementType'
                },
                {
                    name: 'primoPricingArea',
                    claims: [Claims.MasterdataPrimoPricingAreaReader],
                    url: 'report/primo/primoPricingArea'
                },
                {
                    name: 'primoPricingFormula',
                    claims: [Claims.MasterdataPrimoPricingFormulaReader],
                    url: 'report/primo/primoPricingFormula'
                },
                {
                    name: 'primoTranscoMot',
                    claims: [Claims.MasterdataPrimoTranscoMotReader],
                    url: 'report/primo/primoTranscoMot'
                },
                {
                    name: 'primoTranscoProduct',
                    claims: [Claims.MasterdataPrimoTranscoProductReader],
                    url: 'report/primo/primoTranscoProduct'
                },
                {
                    name: 'primoPriceIndexCode',
                    claims: [Claims.MasterdataPrimoPriceIndexCodeReader],
                    url: 'report/primo/primoPriceIndexCode'
                }
            ]
        },
        {
            name: 'fifo',
            cards: [
                {
                    name: 'fifoPerimeters',
                    claims: [Claims.FifoDashboardExport],
                    url: 'report/fifo/perimeter'
                },
                {
                    name: 'fifoTransferOnlySite',
                    claims: [Claims.FifoDashboardExport],
                    url: 'report/fifo/transferOnlySite'
                },
            ]
        },
        {
            name: 'petrostock',
            cards: [
                {
                    name: 'petrostockDepotReference',
                    claims: [Claims.MasterdataPetrostockReader],
                    url: 'stock/petrostock/depotReference'
                },
                {
                    name: 'petrostockEntrepositaire',
                    claims: [Claims.MasterdataPetrostockReader],
                    url: 'stock/petrostock/entrepositaire'
                },
                {
                    name: 'petrostockRegimeDouanier',
                    claims: [Claims.MasterdataPetrostockReader],
                    url: 'stock/petrostock/regimeDouanier'
                },
                {
                    name: 'petrostockIgnoredCompanys',
                    claims: [Claims.MasterdataPetrostockReader],
                    url: 'stock/petrostock/ignoredCompany'
                },
                {
                    name: 'petrostockIgnoredMovementTypes',
                    claims: [Claims.MasterdataPetrostockReader],
                    url: 'stock/petrostock/ignoredMovementType'
                },
                {
                    name: 'petrostockDestinations',
                    claims: [Claims.MasterdataPetrostockReader],
                    url: 'stock/petrostock/destination'
                }
            ]
        }
    ]
}